import React from 'react'
import Menu from './Menu';
import MenuTop from './MenuTop';


const Header = () => {
  return (
    <div className="content header">
          <MenuTop />

          <Menu />
          
    </ div>
  )
}

export default Header